import React from "react";
import { format, parseISO } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "./button";
import { Calendar } from "./calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

/**
 * Shadcn-styled date picker. `value` is an ISO yyyy-MM-dd string;
 * `onChange(isoString)` fires with the same format so it is a drop-in
 * replacement for `<input type="date" />`.
 */
export function DatePicker({ value, onChange, maxDate, disabled, className, "data-testid": testId }) {
  const selected = value ? parseISO(value) : undefined;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          disabled={disabled}
          data-testid={testId}
          className={cn(
            "w-full justify-start text-left font-normal px-4 py-2 border border-gray-300 bg-white hover:bg-gray-50 focus:ring-2 focus:ring-[#156ACA]",
            !selected && "text-muted-foreground",
            className
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4 text-[#156ACA]" />
          {selected ? format(selected, "PPP") : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => {
            if (d) onChange(format(d, "yyyy-MM-dd"));
          }}
          disabled={maxDate ? (d) => d > maxDate : undefined}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
